import Cookies from "js-cookie";

const toasts = document.querySelectorAll("[data-cookie]");
if (toasts.length) {
  toasts.forEach((toast) => {
    const cookieName = toast.getAttribute("data-cookie");

    //Have they dismissed it already?
    if (Cookies.get(cookieName)) {
      toast.classList.remove("show");
    } else {
      toast.classList.add("show");
    }

    //Add event listener to dismiss
    toast.addEventListener("hidden.bs.toast", () => {
      const oneHour = 1 / 24;
      Cookies.set(cookieName, "true", {
        expires: oneHour,
      });
    });
  });
}
